import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Row, Form, Select } from "antd";
import { setZoneDataFun, updateAreaList } from "Store/ZoneSetting/action";
import { createForm } from "./CreatForm";
import { langCheck } from "Pub/js/utils";
import { getMulti } from "Pub/js/getMulti";
import { getMultiLangText } from '../utilService';
const Option = Select.Option;

class SetTemplateLeft extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
    }
    /**
     * 传递 表单的值
     */
    getFromData = () => {
        const { getFieldsValue, validateFields } = this.props.form;
        let flag = false;
        validateFields((err, values) => {
            if (!err) {
                flag = true;
            }
        });
        return flag ? getFieldsValue() : null;
    };
    componentDidMount() {
        this.props.setZoneDataFun(this.getFromData);
    }
    /**
     * @param {*} DOMDATA
     * 添加表头,最新的逻辑为如果出现Form表单区域，就出现设置表头字段
     */
    getFormItem = DOMDATA => {
        let { areaList } = this.props,
            form = [],
            table = [];
        areaList &&
            areaList.map((v, i) => {
                if (v.areatype === "1") {
                    //表单
                    form.push(v);
                } else if (v.areatype === "2") {
                    //表格
                    table.push(v);
                }
            });
        //模板设置显示模板名称
        if (this.props.isImplement) {
            DOMDATA = DOMDATA.filter((v, i) => v.code === "name");
        } else {
            //过滤掉表头列,当页面不存在Form表单区域
            if (form.length !== 0 || table.length !== 0) {
                let item = DOMDATA.find(item => item.code === "headcode");
                if (item) {
                    item.options = creatOption.call(this);
                }
            } else {
                DOMDATA =
                    DOMDATA && DOMDATA.filter((v, i) => v.code !== "headcode");
            }
        }

        function creatOption() {
            let newArray =
                areaList &&
                areaList.filter((v, i) => {
                    return v.areatype !== "0" && v.code;
                });
            return (
                newArray &&
                newArray.map((item, i) => {
                    let name = getMultiLangText(item, 'name', this.props.multiOptions)
                    return (
                        <Option key={item.code} value={item.code}>
                            {name}
                        </Option>
                    );
                })
            );
        }
        return DOMDATA;
    };
    render() {
        let { json, zoneFormData } = this.props;
        let DOMDATA = [
            {
                lable: langCheck(
                    "102202APP-000005",
                    "pages",
                    json
                ) /* 国际化处理： 模板编码*/,
                type: "input",
                code: "code",
                required: true,
                maxlength: 500
            },
            {
                lable: langCheck(
                    "102202APP-000006",
                    "pages",
                    json
                ) /* 国际化处理： 模板名称*/,
                type: "input",
                code: "name",
                required: true,
                disabled: this.props.isImplement,
                maxlength: 500
            },
            {
                lable: langCheck(
                    "102202APP-000007",
                    "pages",
                    json
                ) /* 国际化处理： 多语字段*/,
                type: "input",
                code: "resid",
                maxlength: 50
            },
            {
                lable: langCheck(
                    "102202APP-000008",
                    "pages",
                    json
                ) /* 国际化处理： 模板描述*/,
                type: "input",
                code: "templetdesc",
                required: false,
                maxlength: 800
            },
            {
                lable: langCheck(
                    "102202APP-000009",
                    "pages",
                    json
                ) /* 国际化处理： 聚合类*/,
                type: "input",
                code: "clazz",
                required: false,
                maxlength: 200
            },
            {
                lable: langCheck(
                    "102202APP-000010",
                    "pages",
                    json
                ) /* 国际化处理： 设置表头*/,
                type: "select",
                code: "headcode",
                options: [],
                required: true
            },
            {
                lable: langCheck(
                    "102202APP-000068",
                    "pages",
                    json
                ) /* 国际化处理： 设为默认模板*/,
                type: "radio",
                code: "isdefault",
                hidden: zoneFormData.parentid !== 'root' //复制出来的模板不显示
            }
        ];
        DOMDATA = this.getFormItem(DOMDATA);
        return (
            <Form className="from-card">
                <Row gutter={24}>{createForm(DOMDATA, this.props)}</Row>
            </Form>
        );
    }
}
SetTemplateLeft = Form.create()(SetTemplateLeft); // 必须要包装才能用form的方法
SetTemplateLeft.PropTypes = {
    zoneArr: PropTypes.object.isRequired,
    zoneDatas: PropTypes.object.isRequired,
    setZoneDataFun: PropTypes.func.isRequired
};
export default connect(
    state => {
        let { zoneDatas, json } = state.zoneRegisterData;
        let { areaList, zoneFormData, isImplement } = state.zoneSettingData;
        return { zoneDatas, json, areaList, zoneFormData, isImplement };
    },
    {
        setZoneDataFun,
        updateAreaList
    }
)(SetTemplateLeft);
